import { render, staticRenderFns } from "./platformMerchant.vue?vue&type=template&id=11c34095&scoped=true&"
import script from "./platformMerchant.vue?vue&type=script&lang=js&"
export * from "./platformMerchant.vue?vue&type=script&lang=js&"
import style0 from "./platformMerchant.vue?vue&type=style&index=0&id=11c34095&scoped=true&lang=css&"
import style1 from "./platformMerchant.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c34095",
  null
  
)

export default component.exports